<template>
  <header>
    <div class="d-flex flex-column flex-md-row align-items-center pb-3 mb-4 border-bottom">
      <a class="d-flex align-items-center text-dark text-decoration-none" href="/">
        <img alt="" class="me-2" height="32" src="../assets/img/logo.svg" width="40"/>
        <h3>默默云</h3>
      </a>
    </div>
    <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
      <h3 class="display-4 fw-normal">节点任意选择，能打开即可！</h3>
      <!--      <h3 class="display-4 fw-normal">自动为您寻找可访问的节点</h3>-->
    </div>
  </header>
</template>
<style>
</style>
<script setup>
</script>